import React from "react";

// function Header({ titulo }) {
//   return (
//     <Fragment>
//       <h1>{titulo}</h1>;
//     </Fragment>
//   );
// }

const Header = ({ titulo }) => {
  //Puedo poner codigo JS pero necesito el return
  return <h1>{titulo}</h1>;
};
// const Header = ({ titulo }) => <h1>{titulo}</h1>;
//Se puede dar por implicito el return
export default Header;
